import { FileType } from 'features/content-library/types';

export const ZOOMABLE_CONTENT_TYPES: FileType[] = ['image', 'pdf', 'doc', 'ppt', 'xls'];

export const LOCKED_ZOOM_CONTENT_TYPES: string[] = ['file'];

export const SCREENSHARE_ZOOM_LEVELS = [1, 1.25, 1.5, 2, 2.5];
export const CONTENT_ZOOM_LEVELS = [1, 1.25, 1.5, 2, 2.5, 3];
